import {useParams} from "react-router-dom";
import {PageHeader, ProjectQuota, ProjectToolNav} from "~/components";
import {useCan} from "~/hooks";
import BacklinkReport from "../components/BacklinkReport";

/**
 * Trang tool Backlink của một dự án (`/projects/:id/backlinks`) — #9, §8 bước 3.
 *
 * Tổng backlink / domain giới thiệu / anchor / dofollow-nofollow / mới-mất (DataForSEO
 * Backlinks API, cache dùng chung 7 ngày). Dùng chung cap `keyword` (nhóm tool từ khoá).
 */
function BacklinkHome() {

	const {id} = useParams();
	const canKeyword = useCan('keyword');

	if (!canKeyword) return <div className="container">Bạn không có quyền sử dụng phân tích Backlink.</div>;

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="backlinks" />

			<PageHeader
				icon="fa-light fa-link"
				title="Backlink"
				subtitle="Tổng backlink, domain giới thiệu, anchor text, dofollow/nofollow và diễn biến mới/mất theo tháng"
				actions={<ProjectQuota tool="backlinks" />}
			/>

			<BacklinkReport projectId={id} />
		</div>
	);
}

export default BacklinkHome;
